import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  HeadObject: {
    A_VocTyp: "",
    A_VocTypName: "",
    A_VocNo: "",
    A_PostDt: new Date(), // dd/MM/yyyy
    A_ReceiptDt: new Date(), // dd/MM/yyyy
    A_Loc: "",
    A_LocName: "",
    A_DocStat: "ENTER",
    Truck: "",
    Driver: "",
  },
};

const SliceDcCostCompareHistoryReport = createSlice({
  name: "SliceDcCostCompareHistoryReport",
  initialState: { value: initialState },

  reducers: {
    //including   RESET ALL
    Set_DcCostCompareHistoryReport_Init: (state) => {
      state.value = initialState;
    },

    //RESET HEAD
    Set_DcCostCompareHistoryReport_HeadObject_Init: (state) => {
      state.value.HeadObject = initialState.HeadObject;
    },

    Set_DcCostCompareHistoryReport_HeadObject_Set: (state, action) => {
      state.value.HeadObject = action.payload;
    },
  },
});

export const {
  Set_DcCostCompareHistoryReport_Init,
  Set_DcCostCompareHistoryReport_HeadObject_Set,
  Set_DcCostCompareHistoryReport_HeadObject_Init,
} = SliceDcCostCompareHistoryReport.actions;
export default SliceDcCostCompareHistoryReport.reducer;
